import Header from "@/components/Header";
import BottomTabBar from "@/components/BottomTabBar";

/**
 * DeviceFrame — wraps the whole app inside a "mobile device" looking container
 * on desktop (≥768px), and goes full-bleed on mobile. The authenticated user
 * is read inside Header via useAuth() — this wrapper stays presentational.
 */
export default function DeviceFrame({ children }) {
  return (
    <div
      className="nx-page-bg min-h-screen w-full md:flex md:items-center md:justify-center md:py-6 lg:py-10"
      data-testid="device-frame-page"
    >
      <div
        className="
          relative w-full bg-[#0A0E1A] flex flex-col overflow-hidden
          min-h-screen
          md:min-h-0 md:w-[440px] md:max-w-[440px] md:h-[860px] md:max-h-[90vh]
          md:rounded-[40px] md:border md:border-white/[0.06]
          md:shadow-[0_0_0_1px_rgba(0,229,255,0.08),0_30px_80px_-20px_rgba(0,229,255,0.18),0_0_120px_-30px_rgba(0,229,255,0.25)]
        "
        data-testid="device-frame"
      >
        <div className="nx-device-grain" aria-hidden="true" />

        <Header />

        <main
          className="relative z-[1] flex-1 overflow-y-auto nx-scroll px-5 pb-6"
          data-testid="device-main"
        >
          {children}
        </main>

        <BottomTabBar />
      </div>
    </div>
  );
}
